import React from "react";
import LoginRegisterChoiceDialog, { LoginRegisterStateType}  from "./loginRegisterChoiceDialog";
import UserActionButton from "./userActionButton";

export default function UserActionWithAuthPopupButton(props) {
    
    const [open, setOpen] = React.useState(false);
    const { children, ...rest} = props;

    console.log("UserActionWithAuthPopupButton render with open = " + open);

    const handleOpenDialog = (e) => {
      e.preventDefault();
      setOpen(true);
    };
  
    const handleCloseDialog = (e) => {
      e.preventDefault();
      setOpen(false);
    };

    const onSuccess = () => {
        if (typeof props.onSuccess === "function") { 
          setOpen(false);
          props.onSuccess();     
      }
    }

    const onPreflightValidation = () => {
      if (typeof props.onPreflightValidation === "function") { 
        return props.onPreflightValidation();
      }
      else {
        return true;
      }
  }

    return (
        <React.Fragment>
            <UserActionButton {...rest} onClick={props.onClick} onForbidden={handleOpenDialog} onPreflightValidation={onPreflightValidation} >{children}</UserActionButton>
            <LoginRegisterChoiceDialog
                open={open}
                onClose={handleCloseDialog}
                onSuccess={onSuccess}
                onGetUserContext={props.onGetUserContext}
                onCloseStatetype={LoginRegisterStateType.REGISTER}
                fullWidth={true} 
                maxWidth="md"
            />
        </React.Fragment>
    )
}

